import React, { memo, useMemo } from 'react';
import { View } from 'react-native';
import { rem } from 'design-system';
import SectionHeader from 'design-system/SectionHeader';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import { isWithinNext24Hours } from 'utils/dates';
import AutoinvestActivityCard from './AutoinvestActivityCard';
import PendingAutoinvestCard from './PendingAutoinvestCard';
import UpcomingAutoinvestCard from './UpcomingAutoinvestCard';
const AutoinvestActivityRowItem = ({ activity }) => {
    const styles = useStyles(styleSet);
    const isFlashListItem = 'isLastInSection' in activity;
    const borderStyles = useMemo(() => isFlashListItem
        ? [activity.isLastInSection && styles.lastItem, activity.isFirstInSection && styles.firstItem]
        : [styles.standalone], [activity, styles.lastItem, styles.firstItem, styles.standalone, isFlashListItem]);
    if ('sectionTitle' in activity) {
        return (<SectionHeader horizontalMargins largeVerticalMargins>
        {activity.sectionTitle}
      </SectionHeader>);
    }
    const isPaymentWithinNext24Hours = activity.initiationEta ? isWithinNext24Hours(activity.initiationEta) : false;
    if (activity.status === 'upcoming' || (activity.status === 'skipped' && isPaymentWithinNext24Hours)) {
        return <UpcomingAutoinvestCard activity={activity} containerStyle={[styles.rowItem, borderStyles]}/>;
    }
    if (activity.status === 'pending') {
        return (<PendingAutoinvestCard activity={activity} containerStyle={[styles.rowItem, borderStyles]}/>);
    }
    return (<View style={[styles.rowItem, borderStyles]}>
      <AutoinvestActivityCard activity={activity} btnStyles={borderStyles}/>
    </View>);
};
const styleSet = createStyleSheets((colors) => ({
    rowItem: {
        marginHorizontal: rem(16),
        backgroundColor: colors.cards.onDark,
    },
    firstItem: {
        borderTopLeftRadius: rem(16),
        borderTopRightRadius: rem(16),
    },
    lastItem: {
        borderBottomLeftRadius: rem(16),
        borderBottomRightRadius: rem(16),
    },
    standalone: {
        borderRadius: rem(16),
    },
}));
export default memo(AutoinvestActivityRowItem);
